














import Vue from 'vue'
import ScrollFire from '@/views/mixin/ScrollFire'
import EpisodeTitle from '@/views/templates/kuntama/parts/EpisodeTitle.vue'
import EpisodeBody from '@/views/templates/kuntama/parts/EpisodeBody.vue'

Vue.mixin(ScrollFire)

export default
  components: {
    EpisodeTitle
    EpisodeBody
  }

  data: () ->
    fire_scroll: true
    text: [
      '“燻らのたまご”は、保存料・着色料ともに一切不使用の安心・安全な食品なので、お酒の肴としてだけではなく、お子様のおやつやスポーツ選手の栄養補給としてもお召し上がりいただけます。'
      '献立を彩る一品としての日常使いはもちろんのこと、常温で1年間も保存できるので、災害時に不足しがちな栄養素を補う”非常食”としても活躍します。'
      'たくさんの可能性を秘めた“燻らのたまご”。<br>そんな<span class="red">“燻らのたまご”を宇宙に持っていってもらうことが桑野さんの夢</span>です。その夢を叶えるため、桑野さんは宇宙でも食べられる燻製たまご作りに日夜挑戦しています。'
    ]
  created: () ->
    @$options.scroll_target = '.episode4'
